import { DescriptionReveal } from "@/components/Dialogs/DescriptionReveal";
import Icon from "@/icons";
import { Channel } from "types";
export default function TopChannel({ channel }: { channel: Channel }) {
    return (
        <>
            <div className="flex flex-col w-full sm:rounded-t-2xl z-10">
                <div className="flex flex-col w-full h-full rounded-t-2xl bg-brand-top">
                    <div className="flex flex-col gap-2 p-2 py-2">
                        <div className="flex gap-2 p-2 rounded-lg items-center cursor-pointer justify-between">
                            <div className="flex items-center gap-2">
                                {channel.type === "text" && (
                                    <Icon name="hashtag" size="20" color="#a3a3ac" />
                                )}
                                {channel.type === "todo" && (
                                    <Icon name="todo" size="20" color="#a3a3ac" />
                                )}
                                {channel.type === "watchstream" && (
                                    <Icon name="stream" size="20" color="#a3a3ac" />
                                )}
                                {channel.type === "DM" && (
                                    <Icon name="message" size="20" color="#a3a3ac" />
                                )}
                                {channel.type === "whiteboard" && (
                                    <Icon name="whiteboard" size="20" color="#a3a3ac" />
                                )}
                                {channel.type === "voice" && (
                                    <Icon name="volume" size="20" color="#a3a3ac" />
                                )}
                                <div className="font-semibold flex items-center text-lg gap-2">
                                    <h3>{channel.name}</h3>
                                    {channel.type == "voice" && (
                                    
                                        <div className="bg-brand-green px-1 flex items-center rounded-lg">
                                            <h1 className="text-white font-semibold text-sm">BETA</h1>
                                        </div>
                                    )}
                                </div>
                                {channel.description && (
                                        <div className="border-l-2 ml-2 h-6 w-2 border-brand-gray"/>
                                    )}
                                <DescriptionReveal channel={channel}>
                                <h2 className="text-gray-300/50 text-xs">
                                        {channel.description&&channel?.description?.length > 50 ? `${channel?.description?.slice(0, 50)}...` : channel.description}
                                </h2>
                                </DescriptionReveal>
                            </div>

                            <div className="flex items-center gap-2 hover:text-purple-600">
                                <h1 className="text-purple-500 font-semibold text-base hover:text-purple-600 hover:scale-105 transition-all duration-300 truncate" onClick={
                                    () => {
                                        window.open(`https://twitch.tv/${channel.additionalData?.streamChannel}`, "_blank");
                                    }
                                }>
                                    {channel.additionalData?.streamPlatform === "twitch" && (
                                        <Icon name="twitch" size="20" />
                                    )}
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}